import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import AmazonButton from "@/components/AmazonButton";

const sections = [
  {
    id: "who-we-are",
    heading: "Who We Are",
    body: [
      "AutoNeova is a U.S.-based automotive e-commerce company that serves customers through online marketplaces. AutoNeova was established to provide customers with convenient access to useful automotive replacement and maintenance products.",
      "We focus on responsible product sourcing, clear product information, dependable marketplace operations, and long-term customer trust.",
    ],
  },
  {
    id: "what-we-do",
    heading: "What We Do",
    body: [
      "We identify and offer automotive replacement and maintenance products intended for everyday vehicle upkeep. Our categories include wiper blades, spark plugs and ignition products, general automotive maintenance products, and replacement parts and accessories.",
      "Product selection is reviewed on an ongoing basis, and the range offered may change over time based on quality, compatibility coverage, and customer demand.",
    ],
  },
  {
    id: "how-we-sell",
    heading: "How We Sell",
    body: [
      "Our products are listed and sold through the Amazon US marketplace. Customers complete their purchase within Amazon, using Amazon's checkout, order tracking, and customer support systems.",
      "Eligible inventory is stored and fulfilled through Amazon's fulfillment network, which supports dependable delivery for customers in the United States.",
    ],
  },
  {
    id: "our-approach",
    heading: "Our Approach",
    body: [
      "We aim to keep our operations simple and transparent: a focused product range, accurate listing information, and clear communication with customers and business partners.",
      "Where product information is provided by a supplier or manufacturer, we present it as supplied and direct customers to the applicable Amazon listing for current details.",
    ],
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="About Us | AutoNeova"
        description="AutoNeova is a U.S.-based automotive e-commerce company serving customers through online marketplaces, including the Amazon US marketplace."
        path="/about"
      />
      <PageHeader
        testId="about-page-header"
        eyebrow="About Us"
        title="A U.S.-based automotive e-commerce company"
        intro="AutoNeova serves customers in the United States through online marketplaces, with a focus on practical automotive replacement and maintenance products."
      />

      <div className="bg-white py-16 lg:py-24" data-testid="about-page-content">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          {sections.map((s) => (
            <section key={s.id} id={s.id} data-testid={`about-section-${s.id}`} className="mb-14">
              <h2 className="text-2xl font-extrabold text-[#0B1F33] md:text-3xl">{s.heading}</h2>
              {s.body.map((p) => (
                <p key={p.slice(0, 24)} className="mt-4 text-base leading-relaxed text-[#263238]">
                  {p}
                </p>
              ))}
            </section>
          ))}

          <aside
            data-testid="independence-disclaimer"
            className="rounded-lg border-l-4 border-[#D72638] bg-[#F4F6F8] p-7"
          >
            <h2 className="text-lg font-bold text-[#0B1F33]">Independence Statement</h2>
            <p className="mt-3 text-base leading-relaxed text-[#263238]">
              AutoNeova operates independently. References to third-party brands are used only to
              identify compatible or genuine products where applicable. AutoNeova does not claim
              affiliation with or authorization from any manufacturer unless explicitly stated and
              documented.
            </p>
          </aside>

          <div className="mt-14 flex flex-col gap-4 sm:flex-row">
            <AmazonButton testId="about-amazon-cta" />
            <Link
              to="/contact"
              data-testid="about-contact-link"
              className="inline-flex items-center justify-center rounded-md border-2 border-[#0B1F33] px-6 py-3 text-sm font-semibold text-[#0B1F33] transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#F4F6F8]"
            >
              Contact AutoNeova
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
